import { useQuery } from "@tanstack/react-query";
import { useAppContext } from "@web/route-services/root/AppContext";

/**
 * Retrieves the records for the specified chat.
 *
 * @param chatID - The ID of the chat to retrieve data for
 * @returns The query hook object
 */
export function useChatData(chatID: number) {
  const { access } = useAppContext();
  return useQuery({
    queryKey: ["chats", chatID],
    queryFn: async () => {
      const chat = await access.chat.getByID(chatID);
      return chat;
    }
  });
}
